import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import "./BirthdayPopup.css";
import birthdayImage from "../../assets/images/birthdayPopup.png";

const BirthdayPopup = () => {
  const [show, setShow] = useState(false);

  // Show popup after 1 second
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Run confetti when popup is visible
  useEffect(() => {
    if (show) {
      const canvas = document.getElementById("confetti-canvas");
      if (canvas) {
        const myConfetti = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        myConfetti({
          particleCount: 100,
          spread: 80,
          origin: { y: 0.6 },
          scalar: 1.2,
        });
      }
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={() => setShow(false)}>
      <canvas id="confetti-canvas" className="confetti-canvas" />
      <div
        className="popup-image-container"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={birthdayImage} alt="Free Birthday Meal" />
        <button onClick={() => setShow(false)}>Got it!</button>
      </div>
    </div>
  );
};

export default BirthdayPopup;
